import { withSuspense } from '@/ui/utils/withSuspense'

import { useWithdrawDialog } from './logic/useWithdrawDialog'
import { WithdrawView } from './views/WithdrawView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import { IsolatedPairOverview } from '@/features/isolated-details/types'

type WithdrawDialogContentContainerProps = { closeDialog: () => void } & { 
  walletOverview: MyWalletProps
  pairOverview?: IsolatedPairOverview
}

function WithdrawDialogContentContainer({ closeDialog, walletOverview, pairOverview }: WithdrawDialogContentContainerProps) {
  const {
    objectives,
    actionsContext,
    withdrawOptions,
    assetsToWithdrawFields,
    pageStatus,
    form,
    withdrawAsset,
    currentPositionOverview,
    updatedPositionOverview,
    riskAcknowledgement,
  } = useWithdrawDialog({ walletOverview, pairOverview })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="isolatedWithdraw"
        tokenWithValue={withdrawAsset}
        onProceed={closeDialog}
        proceedText="View in dashboard"
      />
    )
  }

  return (
    <WithdrawView
      withdrawOptions={withdrawOptions}
      objectives={objectives}
      actionsContext={actionsContext}
      form={form}
      assetsToWithdrawFields={assetsToWithdrawFields}
      pageStatus={pageStatus}
      withdrawAsset={withdrawAsset}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
      riskAcknowledgement={riskAcknowledgement}
    />
  )
}

const WithdrawDialogContentContainerWithSuspense = withSuspense(WithdrawDialogContentContainer, DialogContentSkeleton)
export { WithdrawDialogContentContainerWithSuspense as WithdrawDialogContentContainer }
